import type { TFunction } from 'i18next';

/** Stored on the member record when chosen from the list. */
export const MEMBER_TITLE_PRESETS = [
  'Mr',
  'Mrs',
  'Miss',
  'Ms',
  'Dr',
  'Rev',
  'Pastor',
  'Elder',
  'Deacon',
] as const;

export type MemberTitlePreset = (typeof MEMBER_TITLE_PRESETS)[number];

/** Listbox sentinel — never persisted. */
export const MEMBER_TITLE_OTHER = '__other__' as const;

export type MemberTitleListboxValue = MemberTitlePreset | typeof MEMBER_TITLE_OTHER;

export const isMemberTitlePreset = (value: string): value is MemberTitlePreset =>
  (MEMBER_TITLE_PRESETS as readonly string[]).includes(value);

export const memberTitleListboxValue = (title: string): MemberTitleListboxValue | null => {
  const trimmed = title.trim();
  if (!trimmed) return null;
  if (isMemberTitlePreset(trimmed)) return trimmed;
  return MEMBER_TITLE_OTHER;
};

export const memberTitleListboxOptions = (t: TFunction<'people'>) => [
  ...MEMBER_TITLE_PRESETS.map((preset) => ({
    value: preset,
    label: t(`members.form.titleOptions.${preset}`),
  })),
  {
    value: MEMBER_TITLE_OTHER,
    label: t('members.form.titleOther'),
  },
];
